import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function SubscriptionCancel() {
  return (
    <div className="container-narrow py-16 md:py-24" data-testid="subscription-cancel-page">
      <div className="max-w-xl mx-auto card-soft p-8 md:p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-paper text-ink2 flex items-center justify-center mx-auto mb-5">
          <XCircle className="w-9 h-9" />
        </div>
        <h1 className="font-heading text-3xl md:text-4xl font-semibold mb-2">Subscription cancelled</h1>
        <p className="text-ink2 mb-6">You didn&apos;t finish signing up on PayPal, so nothing was charged. Your Explorer access is still active.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/pricing" className="btn-primary" data-testid="back-to-pricing-btn">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to pricing
          </Link>
          <Link to="/studio" className="btn-outline-ink text-sm">Keep tinkering</Link>
        </div>
      </div>
    </div>
  );
}
